import React from 'react';
import './About.css'

const About = () => {
    return (

        // Clients review

        <div>
            <div><h1 className="my-5  text-primary">Clients Review</h1></div>
            <div class="row g-0 service-Detail my-5 py-5 philosophy topServices">
                <div class="col-md-6">
                    <img src="https://thumbs.dreamstime.com/b/doctor-patient-happy-senior-s-office-32203166.jpg" alt="" />
                </div>
                <div class="col-md-6">
                    <div class="card-body   py-5 px-5">
                        <h3 class="card-title">Hello,I am Rekha</h3>
                        <p class="card-text">

                            Patients have an important role to play at each stage of their care and the five safety tips will serve to encourage them to be more involved in their health care.

                            Patients can do a lot of small things to make their health-care experience as safe as possible.

                            Hospitals are places of recovery and healing but there are also safety risks for patients, such as infections, falls and medication errors that can happen despite our best efforts.</p>


                    </div>
                </div>
            </div>


            <div class="row g-0 service-Detail my-5 py-5 philosophy topServices">
                <div class="col-md-6">
                    <img src="https://media.istockphoto.com/photos/medical-happy-caregiver-and-patient-outside-a-home-picture-id186669093?k=6&m=186669093&s=170667a&w=0&h=NjSEACO3ov-3tHlozp_C6dSP7sS0hVBXNPqr5HDMGJI=" alt="" />
                </div>
                <div class="col-md-6">
                    <div class="card-body   py-5 px-5">
                        <h3 class="card-title">Hello,I am Trisha </h3>
                        <p class="card-text">

                            Patients have an important role to play at each stage of their care and the five safety tips will serve to encourage them to be more involved in their health care.

                            Patients can do a lot of small things to make their health-care experience as safe as possible.

                            Hospitals are places of recovery and healing but there are also safety risks for patients, such as infections, falls and medication errors that can happen despite our best efforts.</p>


                    </div>
                </div>
            </div>
            <div class="row g-0 service-Detail my-5 py-5 philosophy topServices">
                <div class="col-md-6">
                    <img src="https://www.medicalnewstoday.com/content/images/articles/305/305702/patient-involvement.jpg" alt="" />
                </div>
                <div class="col-md-6">
                    <div class="card-body   py-5 px-5">
                        <h3 class="card-title">Hello,I am Tarek </h3>
                        <p class="card-text">

                            Patients have an important role to play at each stage of their care and the five safety tips will serve to encourage them to be more involved in their health care.

                            Patients can do a lot of small things to make their health-care experience as safe as possible.

                            Hospitals are places of recovery and healing but there are also safety risks for patients, such as infections, falls and medication errors that can happen despite our best efforts.</p>

                    </div>
                </div>
            </div>


        </div>
    );
};

export default About;

